import * as Turbo from "@hotwired/turbo";
Turbo.config.forms.mode = "optin";
Turbo.start();
